module.exports = __webpack_public_path__ + "img/Ic_Clean-up.ca32e043.svg";